import React from "react";
import { motion } from "framer-motion";
import { Target, Eye, ShieldCheck, Sparkles, Users, Radio } from "lucide-react";
import PageHero from "../components/PageHero";
import { optimizeImageUrl, HERO_PAGE_WIDTH } from "../lib/images";

const VALUES = [
  { icon: ShieldCheck, title: "Güvenilirlik", desc: "Doğrulanmış, tarafsız ve ilkeli yayıncılık anlayışıyla hareket ediyoruz." },
  { icon: Sparkles, title: "Nitelik", desc: "İçeriklerimizi alanında uzman kadromuzla en yüksek kalitede üretiyoruz." },
  { icon: Users, title: "İnsan Odaklılık", desc: "İnsana dair ne varsa; hayatın her alanında izleyicimizin yanındayız." },
  { icon: Radio, title: "Yenilikçilik", desc: "Teknoloji ve içeriği buluşturan modern yayıncılık standartları geliştiriyoruz." },
];

const STATS = [
  { value: "13+", label: "Yıllık Tecrübe" },
  { value: "250+", label: "Program" },
  { value: "5B+", label: "Video İçerik" },
  { value: "10M+", label: "Aylık İzlenme" },
];

export default function About() {
  return (
    <div>
      <PageHero
        title="Hakkımızda"
        subtitle="TV13, insana dair ne varsa hepsini ekranlara taşıyan güvenilir bir yayın platformudur."
        image="https://images.unsplash.com/photo-1625690303837-654c9666d2d0"
      />
      <div className="tv-container py-14 space-y-16">
        <div className="grid lg:grid-cols-2 gap-10 items-center">
          <motion.img
            initial={{ opacity: 0, scale: 0.95 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            src={optimizeImageUrl("https://images.unsplash.com/photo-1742805382153-bb4be26d6031", HERO_PAGE_WIDTH)}
            alt="TV13 Studio"
            loading="lazy"
            decoding="async"
            className="rounded-2xl w-full h-[340px] object-cover border border-[var(--tv-border)]"
          />
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
            <h2 className="font-display font-bold text-3xl text-white">Biz Kimiz?</h2>
            <p className="text-[var(--tv-muted)] mt-4 leading-relaxed">
              TV13, haberden spora, kültürden sanata, ekonomiden yaşama hayatın her alanında nitelikli
              içerikler üreten bir yayın platformudur. Amacımız; doğru bilgiyi, güçlü ve güvenilir bir
              yayıncılık anlayışıyla izleyicilerimize ulaştırmaktır.
            </p>
            <p className="text-[var(--tv-muted)] mt-4 leading-relaxed">
              Alanında uzman kadromuz, modern stüdyolarımız ve yenilikçi teknolojik altyapımızla
              geleceğin medyasını bugünden inşa ediyoruz.
            </p>
          </motion.div>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {[{ icon: Target, title: "Misyonumuz", desc: "Toplumu doğru, tarafsız ve nitelikli içeriklerle bilgilendirmek; hayata dair her alanda değer katan bir yayıncılık sunmak." },
            { icon: Eye, title: "Vizyonumuz", desc: "Teknoloji ve içeriği en iyi şekilde buluşturan, Türkiye'nin en güvenilir ve yenilikçi dijital yayın platformu olmak." }].map((m, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 26 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5, delay: i * 0.1 }}
              className="tv-card p-7">
              <div className="w-12 h-12 rounded-xl bg-[rgba(139,92,246,0.15)] border border-[rgba(168,85,247,0.3)] flex items-center justify-center mb-4">
                <m.icon size={24} className="text-[var(--tv-purple-bright)]" />
              </div>
              <h3 className="text-xl font-bold text-white font-display">{m.title}</h3>
              <p className="text-[var(--tv-muted)] mt-3 leading-relaxed">{m.desc}</p>
            </motion.div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {STATS.map((s, i) => (
            <motion.div key={i} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.4, delay: i * 0.08 }}
              className="tv-card p-6 text-center">
              <p className="font-display font-extrabold text-3xl md:text-4xl tv-glow-text">{s.value}</p>
              <p className="text-[var(--tv-muted)] text-sm mt-2">{s.label}</p>
            </motion.div>
          ))}
        </div>

        <div>
          <h2 className="tv-section-title text-white mb-6"><span className="tv-section-bar" /> Değerlerimiz</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {VALUES.map((v, i) => (
              <motion.div key={i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.45, delay: i * 0.08 }}
                className="tv-card p-6">
                <v.icon size={26} className="text-[var(--tv-purple-bright)] mb-4" />
                <h3 className="text-white font-semibold">{v.title}</h3>
                <p className="text-[var(--tv-muted)] text-sm mt-2 leading-relaxed">{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
